import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-bottom-toolbar',
    templateUrl: './bottom-toolbar.component.html',
    styleUrls: ['./bottom-toolbar.component.scss']
})
export class BottomToolbarComponent implements OnInit {

    @Output() handleSave = new EventEmitter();
    @Output() handleCancel = new EventEmitter();
    @Input() message: string;
    @Input() show = false;

    constructor() {
    }

    ngOnInit() {

    }

    onSave() {
        this.handleSave.emit();
    }

    onCancel() {
        this.handleCancel.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/bottom-toolbar/bottom-toolbar.component.ts